export const convertCrDrToType = (
	crDrInd: string,
	translations: {
		moneyIn: string;
		moneyOut: string;
	},
) => {
	if (!crDrInd) return '';
	if (crDrInd.toLowerCase() === 'cr') {
		return translations.moneyIn;
	}
	if (crDrInd.toLowerCase() === 'dr') {
		return translations.moneyOut;
	}
	return '';
};
